<template>
  <div class="integrated-logistics">
    <div class="banner">
      <img src="../../../assets/img/businessScope/integratedLogistics/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("integratedLogistics.banner.bannerTitle")}}</h1>
          <p>{{$t("integratedLogistics.banner.bannerP")}}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="logistics-service">
        <div class="headline">
          <h1>{{$t("integratedLogistics.logisticsService.headlineTitle")}}</h1>
          <p>{{$t("integratedLogistics.logisticsService.headlineP")}}</p>
        </div>
        <el-row :gutter="30">
            <el-col :span="8" :xs="24" v-for="(item,index) in $t('integratedLogistics.logisticsService.lists')" :key="index">
              <div class="pic-wrap">
                <div class="des-box">
                    <el-popover
                      placement="bottom-start"
                      width="300"
                      :title="item.title"
                      trigger="hover"
                      :content="item.des">
                      <div slot="reference">
                        <h2>{{item.title}}</h2>
                        <p>{{item.des}}</p>
                      </div>
                    </el-popover>
                </div>
                <div class="pic">
                    <img :src="item.picUrl" />
                </div>
              </div>
            </el-col>
        </el-row>
      </div>
      <div class="loremIpsum-dolorSit">
        <div class="headline">
          <h1>{{$t("integratedLogistics.loremIpsumDolorSit.headlineTitle")}}</h1>
          <p>{{$t("integratedLogistics.loremIpsumDolorSit.headlineP")}}</p>
        </div>
        <div class="map">
          <p>{{$t("integratedLogistics.loremIpsumDolorSit.des")}}</p>
          <img :src="$t('integratedLogistics.loremIpsumDolorSit.map')" alt="">
        </div>
        <el-row :gutter="40">
            <el-col :span="12" :xs="24" v-for="(item,index) in $t('integratedLogistics.loremIpsumDolorSit.lists')" :key="index">
              <div class="pic-wrap">
                <div class="des-box">
                    <div class="des-icon"><img :src="item.icon" /></div>
                    <h2>{{item.title}}</h2>
                    <p>{{item.des}}</p>
                </div>
                <img :src="item.picUrl" class="pic"/>
              </div>
            </el-col>
        </el-row>
      </div>
    </div>
    <div class="network-freight" :style="{background:`url( ${$t('integratedLogistics.networkFreight.picUrl')} ) no-repeat`,backgroundSize:cover,
        backgroundPosition: center}">
      <div class="container">
        <div class="headline">
          <h1>{{$t("integratedLogistics.networkFreight.headlineTitle")}}</h1>
          <p>{{$t("integratedLogistics.networkFreight.headlineP")}}</p>
        </div>
        <el-row class="box">
            <el-col :span="6" :xs="24" class="pic-box"> 
              <img src="../../../assets/img/businessScope/integratedLogistics/wlhyApp.png" class="pic"/>
            </el-col>
            <el-col :span="6" :xs="24" v-for="(item,index) in $t('integratedLogistics.networkFreight.lists')" :key="index" class="col">
              <div class="des-box">
                  <div class="des-icon"><img :src="item.icon" /></div>
                  <h2>{{item.title}}</h2>
                  <p>{{item.des}}</p>
              </div>
            </el-col>
        </el-row>
      </div>
    </div>
    <div class="project-case container">
      <div class="headline">
        <h1>{{$t("integratedLogistics.projectCase.headlineTitle")}}</h1>
        <p>{{$t("integratedLogistics.projectCase.headlineP")}}</p>
      </div>
      <el-row :gutter="30">
          <el-col :span="8" :xs="24" v-for="(item,index) in $t('integratedLogistics.projectCase.lists')" :key="index">
            <div class="pic-wrap">
              <div class="des-box">
                <h2>{{item.title}}</h2>
              </div>
              <img :src="item.picUrl" class="pic"/>
            </div>
          </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntegratedLogistics",
  data() {
    return {
    };
  },
  mounted() {
    
    var options = { live: false };
    new this.$wow.WOW(options).init();
  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.integrated-logistics {
  .logistics-service{
    .pic-wrap{
      margin-bottom:60px;
      .pic{
          img{
            width:100%;
          }
      }
      .des-box{
        box-sizing: border-box;
        height: 300px;
        background: #F4F4F4;
        padding:30px;
        
        h2{
          margin-bottom:20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        p{
          color: #888888;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 6;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
        
  }
  .loremIpsum-dolorSit{
    .map{
      width:80%;
      margin:0 auto;
      text-align: center;
      margin-bottom:130px;
      p{
        width:800px;
        margin:0 auto 40px;
        text-align: justify;
      }
    }
    .pic-wrap{
      position: relative;
      margin-bottom:60px;
      overflow: hidden;
      img.pic{
        width:100%;
      }
      .des-box{
        position: absolute;
        left:0;
        top:100%;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        background:rgba(0,0,0,0.42);
        color:#fff;
        padding:30px;
        box-sizing: border-box;
        transition: all 0.4s;
        .des-icon{
          text-align: center;
        }
        h2{
          text-align: center;
          margin:10px 0;
        }
        p{
          text-align: justify;
        }
      }
      &:hover{
        .des-box{
          top:0;
        }
      }
    }
  }
  .network-freight{
    
    height:900px;
    margin-top: 100px;
    margin-bottom: 200px;
    .headline{
      h1,p{
        color:#fff;
      }
    }
    .box{
      border:1px solid #DBDBDB;
      height: 500px;
      box-sizing: border-box;
      position: absolute;
      left:0;
      top:900px;
      margin-top:-300px;
      .pic-box{
        background: rgb(235,235,235);
        height:100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .col{
        background: #F1F1F3;
        height:100%;
        padding:40px 0;
        .des-box{
          padding:0 30px;
          height:100%;
          border-right:1px solid #DBDBDB;
          .des-icon{
            text-align: center;
          }
          h2{
            text-align: center;
            margin:20px 0;
          }
        }
      }
    }
    
  }
  .project-case{
    .pic-wrap{
      position: relative;
      margin-bottom:60px;
      border-radius: 10px;
      overflow: hidden;
      img.pic{
        width:100%;
      }
      .des-box{
        position: absolute;
        left:0;
        top:100%;
        width: 100%;
        padding:10px;
        background:rgba(255,255,255,0.8);
        box-sizing: border-box;
        text-align: center;
        transition: all 0.4s;
      }
      &:hover{
        .des-box{
          // transform: translateY(-60px);
          top:auto;
          bottom:0;
        }
      }
    }
  }
  @media screen and (max-width:768px){
    .logistics-service{
      .pic-wrap{
        margin-bottom:40px;
        .des-box{
          height: auto;
          background: #F4F4F4;
          padding:30px;
          
          h2{
            display: block;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: none;
            overflow:visible;
            text-overflow: clip;
          }
          p{
            display: block;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: none;
            overflow: visible;
            text-overflow: clip;
          }
        }
      }
          
    }
    .loremIpsum-dolorSit{
      .map{
        width:100%;
        margin-bottom:40px;
        p{
          width:100%;
          margin:0 auto 40px;
        }
      }
      .pic-wrap{
        position: relative;
        margin-bottom:40px;
        overflow: hidden;
        img.pic{
          width:100%;
        }
        .des-box{
          position: relative;
          left:0;
          top:0;
          width: 100%;
          height: auto;
          border-radius: 10px;
          background:#0054A7;
          color:#fff;
          padding:15px;
          box-sizing: border-box;
          transition: all 0.4s;
          margin-bottom:20px;
          .des-icon{
            img{
              width:50px;
            }
          }
          h2{
            font-size: 18px;
          }
          p{
            line-height: 1.2;
          }
        }
      }
    }
    .network-freight{
      height:auto;
      margin-top: 0;
      margin-bottom: 40px;
      background:none !important;
      .headline{
        h1,p{
          color:#333;
        }
      }
      .box{
        border:1px solid #DBDBDB;
        height: auto;
        box-sizing: border-box;
        position: relative;
        left:0;
        top:0;
        margin-top:0;
        .pic-box{
          padding:20px 0;
        }
      }
      
    }
    .project-case{
      .pic-wrap{
        position: relative;
        margin-bottom:60px;
        border-radius: 10px;
        overflow: hidden;
        .des-box{
          position: absolute;
          left:0;
          bottom:0;
          top:auto;
          width: 100%;
          padding:10px;
          background:rgba(255,255,255,0.8);
          box-sizing: border-box;
          text-align: center;
          transition: all 0.4s;
          h2{
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
